import React, { CSSProperties } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { mergeStyles } from "@fluentui/react";
import { getLogoImages } from "../../layout/chatSidebar";
import { getThemeColors } from "../../theme/colors";

interface SidebarHeaderProps {
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
  username: string;
  colorMode: string;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  isCollapsed,
  setIsCollapsed,
  username,
  colorMode,
}) => {
  const currentColors = getThemeColors(username, colorMode as "light" | "dark");

  const toggleButtonStyle: CSSProperties = {
    position: "absolute",
    right: "-1px",
    top: "50%",
    transform: "translateY(-50%)",
    backgroundColor: currentColors.background,
    border: `1px solid ${currentColors.border}`,
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    zIndex: 2,
    color: currentColors.text,
  };

  const logoContainerStyle: CSSProperties = {
    height: isCollapsed ? 37 : 37 * 1.2,
    paddingTop: 30,
    paddingBottom: 35,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <div>
      <div
        style={toggleButtonStyle}
        onClick={() => setIsCollapsed(!isCollapsed)}
        title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        {isCollapsed ? (
          <FiChevronRight size={16} />
        ) : (
          <FiChevronLeft size={16} />
        )}
      </div>

      <div style={logoContainerStyle}>
        {isCollapsed ? (
          <img
            src={getLogoImages(username, colorMode).collapsed}
            alt="Logo"
            style={{ height: "100%", width: "auto" }}
          />
        ) : (
          <img
            src={getLogoImages(username, colorMode).expanded}
            alt="Logo"
            className={mergeStyles({
              height: 37 * 1.5,
              width: "auto",
            })}
          />
        )}
      </div>
    </div>
  );
};
